import {
  getMyTripsApi,
  updateTripNameApi,
  getMyTripsCountApi,
  getRebookPassengersApi,
  getMessageApi,
} from '../../services/api/mytrips.service';
import { selectAccessToken } from '../selectors/auth.selector';
import { selectMytrips } from '../selectors/mytrips.selector';
import { openAlert } from './alert';
import { logException } from '../../utils/logger.utils.native';
import { getDutyOfCareByTripKeyApi } from '../../services/aws/trip.service';
import to from '../../utils/to';
import i18n from '../../i18n';
import * as RootNavigation from '../../utils/navigationRef';
export const SET_MYTRIPS_RESULTS = 'SET_MYTRIPS_RESULTS';
export const SET_MYTRIPS_COUNT = 'SET_MYTRIPS_COUNT';
export const CLEAR_MYTRIPS_RESULTS = 'CLEAR_MYTRIPS_RESULTS';
export const SET_REBOOK_PASSENGERS = 'SET_REBOOK_PASSENGERS';
export const UNCHECK_REBOOK_PASSENGERS = 'UNCHECK_REBOOK_PASSENGERS';
export const CHECK_REBOOK_PASSENGERS = 'CHECK_REBOOK_PASSENGERS';
export const FILTER_TRIPS = 'FILTER_TRIPS';
export const SELECT_TRIP = 'SELECT_TRIP';
export const UPDATE_TRIPNAME = 'UPDATE_TRIPNAME';
export const UPDATE_MYTRIPS_RESULTS = 'UPDATE_MYTRIPS_RESULTS';
export const SET_DUTY_OF_CARE = 'SET_DUTY_OF_CARE';
export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_LOADING = 'SET_LOADING';
import { guestTokenUserName } from '../../constants/Configs';
import { getToken } from './auth';
import getPassengersNotInfantType from '../../utils/passenger.util';
import PassengerTypes from '../../constants/PassengerTypes';

export const getMyTrips = (initialCount, count, type) => {
  return async (dispatch, getState) => {
    try {
      const accessToken = selectAccessToken(getState());
      const myTrips = await getMyTripsApi(accessToken, initialCount, count, type);
      dispatch({ type: SET_MYTRIPS_RESULTS, myTrips });
    } catch (error) {
      console.error(error);
      logException(error, {
        metaData: {
          message: 'Getting Trips Failed.',
          error,
        },
      });
    }
  };
};

export const getTripCount = () => {
  return async (dispatch, getState) => {
    try {
      const accessToken = selectAccessToken(getState());
      const myTripsCount = await getMyTripsCountApi(accessToken);
      dispatch({ type: SET_MYTRIPS_COUNT, myTripsCount });
    } catch (error) {
      console.error(error);
      logException(error, {
        metaData: {
          message: 'Getting Trip Count Failed.',
          error,
        },
      });
    }
  };
};

export const getRebookPassengers = (lastName, confirmationNumber) => {
  return async (dispatch) => {
    try {
      const [err, rebookPassengers] = await to(
        getRebookPassengersApi(lastName, confirmationNumber)
      );
      if (err) {
        dispatch(openAlert({ message: i18n.t('login:UserAuthenticate.WrongUserCredentials') }));
        logException(err, { metaData: { lastName, confirmationNumber } });
        return;
      } else {
        const tempPax = [];
        rebookPassengers.RebookPassengerList.filter((pax) => {
          if (pax.PassengerType === PassengerTypes.ADULT) {
            tempPax.push(pax);
          }
        });
        rebookPassengers.RebookPassengerList.filter((pax) => {
          if (pax.PassengerType === PassengerTypes.SENIOR) {
            tempPax.push(pax);
          }
        });
        rebookPassengers.RebookPassengerList.filter((pax) => {
          if (pax.PassengerType === PassengerTypes.CHILD) {
            tempPax.push(pax);
          }
        });
        rebookPassengers.RebookPassengerList.filter((pax) => {
          if (pax.PassengerType === PassengerTypes.YOUTH) {
            tempPax.push(pax);
          }
        });
        rebookPassengers.RebookPassengerList.filter((pax) => {
          if (pax.PassengerType === PassengerTypes.INFANT) {
            tempPax.push(pax);
          }
        });
        rebookPassengers.RebookPassengerList.filter((pax) => {
          if (pax.PassengerType === PassengerTypes.INFANTWITHSEAT) {
            tempPax.push(pax);
          }
        });
        rebookPassengers.RebookPassengerList = tempPax;
        await dispatch({ type: SET_REBOOK_PASSENGERS, rebookPassengers });
        await dispatch(getToken(guestTokenUserName), '');
      }
    } catch (error) {
      console.error(error);
      logException(error, {
        metaData: {
          message: 'getRebookPassengersApi Failed.',
          error,
        },
      });
    }
  };
};

export const checkRebookPassengers = (checkedPassenger) => {
  return async (dispatch) => {
    dispatch({ type: CHECK_REBOOK_PASSENGERS, checkedPassenger });
  };
};

export const uncheckRebookPassengers = (checkedPassenger) => {
  return async (dispatch) => {
    dispatch({ type: UNCHECK_REBOOK_PASSENGERS, checkedPassenger });
  };
};
// export const fetchRebookPassenger = () => {
//   return async (dispatch, getState) => {
//     try {
//       const accessToken = selectAccessToken(getState());
//       const rebookPassengers = await getRebookPassengersApi(accessToken);
//       const passengerTypeArr = await getPassengersNotInfantType(
//         rebookPassengers.RebookPassengerList
//       );
//       console.log(passengerTypeArr);
//       dispatch({ type: SET_REBOOK_PASSENGERS, rebookPassengers });
//     } catch (error) {
//       console.error(error);
//       logException(error, {
//         metaData: {
//           message: 'Getting Rebook Passengers Failed.',
//           error,
//         },
//       });
//     }
//   };
// };
export const updateMyTrips = (initialCount, count, type) => {
  return async (dispatch, getState) => {
    try {
      const accessToken = selectAccessToken(getState());
      const myTrips = await getMyTripsApi(accessToken, initialCount, count, type);
      dispatch({ type: UPDATE_MYTRIPS_RESULTS, myTrips });
    } catch (error) {
      logException(error, {
        metaData: {
          message: 'Updating Trips Failed.',
          error,
        },
      });
    }
  };
};

export const clearMyTrips = () => {
  return async (dispatch) => {
    dispatch({ type: CLEAR_MYTRIPS_RESULTS });
  };
};

export const selectTrip = (tripSelected) => {
  return (dispatch) => {
    dispatch({
      type: SELECT_TRIP,
      tripSelected,
    });
  };
};

export const getLastDutyOfCareByTripKey = (tripKey) => {
  return async (dispatch) => {
    try {
      const res = await getDutyOfCareByTripKeyApi(tripKey);
      if (res.LastCheckIn === false) {
        dispatch({ type: SET_DUTY_OF_CARE, lastDate: '' });
      } else {
        dispatch({ type: SET_DUTY_OF_CARE, lastDate: new Date(res.LastCheckIn + 'Z') });
      }
    } catch (error) {
      console.warn(error);
    }
  };
};

export const filterTrips = (tripsFilters, isAnyFilterApplied) => {
  return async (dispatch) => {
    dispatch({ type: FILTER_TRIPS, tripsFilters, isAnyFilterApplied });
  };
};

export const updateTripName = (tripId, tripName) => {
  return async (dispatch, getState) => {
    const accessToken = selectAccessToken(getState());
    const currentMyTrips = selectMytrips(getState());
    const response = await updateTripNameApi(accessToken, tripId, tripName);
    const tripIndex = currentMyTrips.findIndex((trip) => Number(trip.TripKey) === Number(tripId));
    if (response === 'success') {
      dispatch({ type: UPDATE_TRIPNAME, tripName, tripIndex });
      dispatch(
        openAlert({
          title: 'The trip name was successfully updated',
          confirmText: 'Ok',
        })
      );
    } else {
      dispatch(
        openAlert({
          title: 'Change trip name is not possible now, please try again later',
          confirmText: 'Accept',
        })
      );
      logException('update trip name failed', { metaData: { tripId, tripName } });
      return;
    }
  };
};

export const getPageMessage = (companyID, groupKey, pageKey) => {
  return async (dispatch) => {
    const messages = await getMessageApi(companyID, groupKey, pageKey);
    dispatch({
      type: SET_MESSAGES,
      messages,
    });
  };
};

export const setLoadingState = (loading) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, loading });
  };
};
